import * as tslib_1 from "tslib";
import { Matrix3D, Vector3D } from "@awayjs/core";
import { TraverserBase } from "@awayjs/graphics";
import { BoundsType } from "../bounds/BoundsType";
import { CubeMapShadowMapper } from "../shadowmappers/CubeMapShadowMapper";
import { LightBase } from "./LightBase";
var PointLight = (function (_super) {
    tslib_1.__extends(PointLight, _super);
    function PointLight() {
        var _this = _super.call(this) || this;
        _this._pRadius = 90000;
        _this._pFallOff = 100000;
        _this._pIsEntity = true;
        _this._pFallOffFactor = 1 / (_this._pFallOff * _this._pFallOff - _this._pRadius * _this._pRadius);
        //default bounds type
        _this._boundsType = BoundsType.SPHERE;
        return _this;
    }
    Object.defineProperty(PointLight.prototype, "traverseName", {
        get: function () {
            return PointLight.traverseName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PointLight.prototype, "assetType", {
        get: function () {
            return PointLight.assetType;
        },
        enumerable: true,
        configurable: true
    });
    PointLight.prototype.pCreateShadowMapper = function () {
        return new CubeMapShadowMapper();
    };
    Object.defineProperty(PointLight.prototype, "radius", {
        get: function () {
            return this._pRadius;
        },
        set: function (value) {
            this._pRadius = value;
            if (this._pRadius < 0) {
                this._pRadius = 0;
            }
            else if (this._pRadius > this._pFallOff) {
                this._pFallOff = this._pRadius;
                this._pInvalidateBounds();
            }
            this._pFallOffFactor = 1 / (this._pFallOff * this._pFallOff - this._pRadius * this._pRadius);
        },
        enumerable: true,
        configurable: true
    });
    PointLight.prototype.iFallOffFactor = function () {
        return this._pFallOffFactor;
    };
    Object.defineProperty(PointLight.prototype, "fallOff", {
        get: function () {
            return this._pFallOff;
        },
        set: function (value) {
            this._pFallOff = value;
            if (this._pFallOff < 0)
                this._pFallOff = 0;
            if (this._pFallOff < this._pRadius)
                this._pRadius = this._pFallOff;
            this._pFallOffFactor = 1 / (this._pFallOff * this._pFallOff - this._pRadius * this._pRadius);
            this._pInvalidateBounds();
        },
        enumerable: true,
        configurable: true
    });
    PointLight.prototype._pUpdateSphereBounds = function () {
        _super.prototype._pUpdateSphereBounds.call(this);
        this._pSphereBounds.radius = this._pFallOff;
    };
    PointLight.prototype.iGetObjectProjectionMatrix = function (displayObject, cameraTransform, target) {
        if (target === void 0) { target = null; }
        if (!target)
            target = new Matrix3D();
        var m = Matrix3D.CALCULATION_MATRIX;
        // todo: do not use lookAt on Light
        m.copyFrom(displayObject.getRenderSceneTransform(cameraTransform));
        m.append(this._pParent.transform.inverseConcatenatedMatrix3D);
        this.lookAt(m.position);
        m.copyFrom(displayObject.getRenderSceneTransform(cameraTransform));
        m.append(this.transform.inverseConcatenatedMatrix3D);
        var box = displayObject.getBox();
        var v1 = m.deltaTransformVector(new Vector3D(box.left, box.bottom, box.front));
        var v2 = m.deltaTransformVector(new Vector3D(box.right, box.top, box.back));
        var d1 = v1.x * v1.x + v1.y * v1.y + v1.z * v1.z;
        var d2 = v2.x * v2.x + v2.y * v2.y + v2.z * v2.z;
        var d = Math.sqrt(d1 > d2 ? d1 : d2);
        var zMin;
        var zMax;
        var z = m._rawData[14];
        zMin = z - d;
        zMax = z + d;
        var targetData = target._rawData;
        targetData[5] = targetData[0] = zMin / d;
        targetData[10] = zMax / (zMax - zMin);
        targetData[11] = 1;
        targetData[1] = targetData[2] = targetData[3] = targetData[4] = targetData[6] = targetData[7] = targetData[8] = targetData[9] = targetData[12] = targetData[13] = targetData[15] = 0;
        targetData[14] = -zMin * targetData[10];
        target.prepend(m);
        return target;
    };
    return PointLight;
}(LightBase));
export { PointLight };
PointLight.traverseName = TraverserBase.addEntityName("applyPointLight");
PointLight.assetType = "[light PointLight]";



// WEBPACK FOOTER //
// ../dist/lib/display/PointLight.js